import { useNavigate } from "react-router-dom";
import { getAllRealWarehouses } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import UtilsFormule from "../../utils/UtilsFormule";
import EditRealDeviseWarehouse from "../../ui/EditRealDeviseWarehouse";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../components/layouts/WithLoader";
import WarehouseService from "../../services/PosService/WarehouseService";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";

const WarehousesManagers = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [availableRealWarehouses, setAvailableRealWarehouses] = useState([]);
  const [availableNotRealWarehouses, setAvailableNotRealWarehouses] = useState(
    []
  );
  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const [oldDeviseWarehouseData, setOldDeviseWarehouseData] = useState();
  const [onEditDeviseWarehouse, setOnEditDeviseWarehouse] = useState(false);
  const [showElement, setShowElement] = useState([]);
  //alert
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  useEffect(() => {
    startLoading();
    WarehouseService.getAllStockShopByManager(getCurrentUserId())
      .then((response) => {
        setAvailableNotRealWarehouses(response?.data?.vitual);
        setAvailableRealWarehouses(response?.data?.real);
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);

  const onAddWarehouseHandler = () => {
    navigate(`/addWarehouse`);
  };
  const onEditWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference,
    oldWarehouseManagerId
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      name: oldWarehouseName,
      description: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
      warehouseManagerId: oldWarehouseManagerId,
    };
    setOldWarehouseData(oldWarehouseData);
    setOnEditWarehouse(true);
  };
  const onEditDeviseWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      oldWarehouseName: oldWarehouseName,
      oldWarehouseDesc: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
    };
    setOldDeviseWarehouseData(oldWarehouseData);
    setOnEditDeviseWarehouse(true);
  };

  const onViewProductsHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouse", warehouseId);
    sessionStorage.setItem("typeDocument", "Warehouse");
    navigate("/warehouseProducts");
  };

  const onViewMouvementHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouseMouvement", warehouseId);
    sessionStorage.setItem("nameWarehouseMouvement", warehouseName);
    navigate("/warehouseMouvement");
  };
  const onViewProductsPriceHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouse", warehouseId);
    sessionStorage.setItem("typeDocument", "Warehouse");
    navigate("/warehouseProductsByPrices");
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les dépôts</h5>

                  {/* {!showElement.includes("WAREHOUSE_MANAGER") && (
                    <button
                      class="btn btn-dark  float-right"
                      onClick={onAddWarehouseHandler}
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  )} */}
                </div>
              </div>
              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les dépôts disponible</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr className="text-center">
                          <th style={{ width: "12%" }}>Réference</th>
                          <th style={{ width: "12%" }}>Libellé</th>
                          <th style={{ width: "12%" }}>DC</th>
                          <th style={{ width: "12%" }}>Devise</th>
                          <th style={{ width: "12%" }}> Modifier</th>
                          <th style={{ width: "12%" }}> Voir Plus</th>
                          <th style={{ width: "12%" }}> Prix</th>
                          <th style={{ width: "12%" }}> Mouvements</th>
                        </tr>
                      </thead>
                      <tbody>
                        {availableRealWarehouses &&
                          availableRealWarehouses.map((element, i) => (
                            <tr key={element.id}>
                              <td>{element.ref} </td>

                              <td>{element.name}</td>

                              <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td>
                              {element.devise !== null ? (
                                <td className="text-center">
                                  <label>{element.devise}</label>
                                </td>
                              ) : (
                                <td className="text-center">
                                  <button
                                    style={{ width: 40 }}
                                    class="btn bg-gray btn-sm "
                                    data-toggle="modal"
                                    data-target="#devise-warehouse"
                                    onClick={() =>
                                      onEditDeviseWarehouseHandler(
                                        element.id,
                                        element.name,
                                        element.description,
                                        element.ref
                                      )
                                    }
                                  >
                                    <i class="fas fa-pencil-alt"></i>
                                  </button>
                                </td>
                              )}
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-gray btn-sm "
                                  data-toggle="modal"
                                  data-target="#edit-warehouse"
                                  onClick={() =>
                                    onEditWarehouseHandler(
                                      element.id,
                                      element.name,
                                      element.description,
                                      element.ref,
                                      element.warehouseManegerId
                                    )
                                  }
                                >
                                  <i class="fas fa-pencil-alt"></i>
                                </button>
                              </td>

                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-black btn-sm "
                                  onClick={() =>
                                    onViewProductsHandler(
                                      element.id,
                                      element.name
                                    )
                                  }
                                >
                                  <i class="fas fa-folder"></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-black btn-sm "
                                  onClick={() =>
                                    onViewProductsPriceHandler(
                                      element.id,
                                      element.name
                                    )
                                  }
                                >
                                  <i class="fas fa-coins"></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-black btn-sm "
                                  onClick={() =>
                                    onViewMouvementHandler(
                                      element.id,
                                      element.ref + "-" + element.name
                                    )
                                  }
                                >
                                  <i class="fas fa-solid fa-chart-line"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>

              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les dépôts systèmes</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr className="text-center">
                          <th style={{ width: "12%" }}>Réference</th>
                          <th style={{ width: "12%" }}>Libellé</th>
                          <th style={{ width: "12%" }}>DC</th>
                        </tr>
                      </thead>
                      <tbody>
                        {availableNotRealWarehouses &&
                          availableNotRealWarehouses.map((element, i) => (
                            <tr key={element.id}>
                              <td>{element.ref} </td>

                              <td>{element.name}</td>

                              <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      {onEditDeviseWarehouse && (
        <EditRealDeviseWarehouse
          setOnEditDeviseWarehouse={setOnEditDeviseWarehouse}
          oldDeviseWarehouseData={oldDeviseWarehouseData}
        />
      )}
      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(WarehousesManagers);
